import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use useRef to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const sessionId = hash.split("session_id=")[1]?.split("&")[0];

        if (!sessionId) {
          throw new Error("Session ID non trovato");
        }

        // Send session_id to backend
        const response = await fetch(`${API}/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId })
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.detail || "Errore durante l'autenticazione");
        }

        // Check if we are in the admin flow
        const isAdminCallback = location.pathname.includes("/admin/callback");

        if (isAdminCallback) {
          if (data.is_admin) {
            toast.success("Accesso Admin effettuato!");
            navigate("/admin", { replace: true });
          } else {
            // Not an admin - logout and show error
            await fetch(`${API}/auth/logout`, { method: "POST", credentials: "include" });
            toast.error("Accesso negato: Non hai i privilegi di amministratore");
            navigate("/admin/login", { replace: true });
          }
        } else {
          // Standard user flow
          toast.success("Accesso effettuato con Google!");
          navigate("/dashboard", { state: { user: data }, replace: true });
        }

      } catch (error) {
        console.error("Auth callback error:", error);
        toast.error(error.message || "Errore durante l'autenticazione");
        const isAdminCallback = location.pathname.includes("/admin/callback");
        navigate(isAdminCallback ? "/admin/login" : "/auth", { replace: true });
      }
    };

    processSession();
  }, [navigate, location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-muted-foreground">Completamento accesso...</p>
      </div>
    </div>
  );
}
